export type Client = any

export interface ClientsState {
    loading: boolean
    loadingdata: boolean
    resultclient: string | null
    clients: Client[]
    clientsForSelect: Client[]
    client: Client | null
    total: number
}

const initialState: ClientsState = {
    loading: false,
    loadingdata: false,
    resultclient: null,
    clients: [],
    clientsForSelect: [],
    client: null,
    total: 0,
}

export const clientsReducer = (state: ClientsState = initialState, action: { type: string; payload?: any }): ClientsState => {
    switch (action.type) {
        case "CLIENT_GETALL_SUCCESS":
            return {
                ...state,
                loading: false,
                clients: action.payload.clients as Client[],
                total: action.payload.total,
                resultclient: null,
            }

        case "CLIENT_GETALLFORSELECT_SUCCESS":
            return {
                ...state,
                clientsForSelect: action.payload as Client[],
                loading: false,
                resultclient: null,
            }

        case "CLIENT_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                client: action.payload.client as Client,
            }

        case "CLIENT_EDIT_SUCCESS":
            return {
                ...state,
                loading: false,
                resultclient: action.payload.message as string
            }

        case "CLIENT_RESET_RESULT":
            return {
                ...state,
                resultclient: null,
            }

        case "CLIENT_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "CLIENT_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }

        case "CLIENTDATA_GET_SUCCESS":
            return {
                ...state,
                loadingdata: false,
                client: action.payload.client as Client,
            }

        case "CLIENT_CODE_SUCCESS":
            return {
                ...state,
                loading: false,
                resultclient: action.payload.message as string
            }

        case "CLIENT_CODE_ERROR":
            return {
                ...state,
                loading: false,
                resultclient: action.payload.message
            }

        case "CLIENTDATA_LOADING":
            return {
                ...state,
                loadingdata: true,
            }

        case "CLIENTDATA_NOT_LOADING":
            return {
                ...state,
                loadingdata: false,
            }

        default:
            return state
    }
}
